<template>
    <div class="container-top">
        <div class="container container-header flex items-center justify-center">
            <div class="flex container-header-left justify-between items-end">
                <div v-for="(item, index) in leftList" :key="index" @click="onHandleLink(item)">
                    <span>{{item.title}}</span>
                </div>
            </div>
            <div class="container-header-logo flex items-center">
                <div class="container-header-center"></div>
            </div>
            <div class="flex container-header-right justify-end items-center">
                <!-- 搜索 -->
                <div class="head-search right-bar">
                    <input
                        type="text"
                        ref="inputs"
                        @keyup.enter="handleGoSearch"
                        v-model="inputContent"
                        class="header-input"
                        :class="{'input-active': inputState}"
                        placeholder="Search for goods "
                    />
                    <span
                        class="iconfont iconsousuo header-right-iconfont"
                        @click.stop="handleFocus"
                    ></span>
                </div>
                <router-link
                    v-for="(item, ind) in rightList"
                    :key="ind"
                    :to="{name: item.link}"
                    tag="div"
                    class="right-bar"
                >
                    <span
                        v-if="ind !== 2"
                        class="header-right-iconfont iconfont"
                        :class="item.icon"
                    >{{ind === 0 && userToken ? `(${wishTotal})` : ''}}</span>
                    <span v-else>
                        <span
                            v-if="!userToken"
                            class="header-right-iconfont iconfont"
                            :class="item.icon"
                        ></span>
                    </span>
                </router-link>
                <!-- 个人中心 -->
                <div class="avatar-father" v-if="userToken">
                    <!-- <span class="iconfont icongerenyonghutouxiang2 header-right-iconfont"></span> -->
                    <div class="avatar" data-tag="__hbm__" @click="menuState = !menuState">
                        <div
                            data-tag="__hbm__"
                            class="avatar-img"
                            :style="`background-image:url(${avatarImg});`"
                        ></div>
                        <div data-tag="__hbm__" class="menu" v-if="menuState">
                            <ul data-tag="__hbm__">
                                <router-link
                                    @click.stop="menuState = false"
                                    v-for="(it, ind) in menuList"
                                    :key="ind"
                                    tag="li"
                                    :to="{name: it.link}"
                                >{{it.name}}</router-link>
                                <li @click="handleSignOut">sign out</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'HeaderBar',
    props: {
        wishTotal: {
            type: Number,
        },
    },
    watch: {
        $route(to, from) {
            if (to.path !== '/search/search-items') {
                this.inputState = false;
            }
            if (localStorage.getItem('aobiyaUserInfos')) {
                this.fetchUserInfo();
            }
            this.toPath = to.name;
            sessionStorage.setItem('toPath', this.toPath);
            this.fromPath = from.name;
            if (to.name === 'productDetail' && !from.name && localStorage.getItem('aobiyaUserInfos')) {
                sessionStorage.setItem('goodsViewTime', parseInt(new Date().valueOf() / 1000, 10));
            } else if (from.name === 'productDetail' && localStorage.getItem('aobiyaUserInfos')) {
                const goodsTime = sessionStorage.getItem('goodsViewTime') ? parseInt(new Date().valueOf() / 1000, 10) -
                    sessionStorage.getItem('goodsViewTime') : 0;
                API.post('/api/aobiya/time/counter/spu', {
                    guest_id: this.aobiyaUserInfos.id,
                    seconds: goodsTime,
                    spu_id: sessionStorage.getItem('spu_id'),
                }).then(() => {
                });
            }
        },
    },
    data() {
        return {
            avatarImg: require('@/assets/images/women.png'),
            avatarTest: require('@/assets/images/women.png'),
            juxingImg: require('@/assets/images/juxing.png'),
            inputState: false,
            menuState: false,
            inputContent: '',
            userToken: false,
            fromPath: '',
            toPath: '',
            aobiyaUserInfos: {},
            rightList: [
                // {
                //     icon: 'iconsousuo',
                //     link: '/',
                // },
                {
                    icon: 'iconshoucang',
                    link: 'wishProduct',
                },
                {
                    icon: 'icongouwuche',
                    link: 'shoppingCart',
                },
                {
                    icon: 'icongerenyonghutouxiang2',
                    link: 'PersonInfo',
                },
            ],
            menuList: [
                {
                    name: 'Personal Details',
                    link: 'PersonInfo',
                },
                {
                    name: 'My Orders',
                    link: 'PersonOrders',
                },
                {
                    name: 'Feedback',
                    link: 'PersonBack',
                },
            ],
        };
    },
    methods: {
        onHandleLink(item) {
            sessionStorage.removeItem('page');
            this.$router.push({
                name: item.link,
                params: { series_id: item.id },
                query: { goods_id: item.title !== 'Home' ? '-1' : '' },
            });
        },
        handleFocus() {
            if (!this.inputState) {
                this.inputState = true;
                this.$refs.inputs.focus();
            } else {
                this.handleGoSearch();
            }
        },
        handleGoodsTime() {
            const goodsTime = sessionStorage.getItem('goodsViewTime') ? parseInt(new Date().valueOf() / 1000, 10) -
                sessionStorage.getItem('goodsViewTime') : 0;
            API.post('/api/aobiya/time/counter/spu', {
                guest_id: this.aobiyaUserInfos.id,
                seconds: goodsTime,
                spu_id: sessionStorage.getItem('spu_id'),
            }).then(() => {
                this.handleViewTime();
            });
        },
        handleSignOut() {
            if (this.toPath === 'productDetail') {
                this.handleGoodsTime();
            } else {
                this.handleViewTime();
            }
        },
        handleViewTime() {
            const startViewTime = sessionStorage.getItem('startViewTime') ? parseInt(new Date().valueOf() / 1000, 10) -
                sessionStorage.getItem('startViewTime') : 0;
            API.post('/api/aobiya/time/counter/guest', {
                guest_id: this.aobiyaUserInfos.id,
                seconds: startViewTime,
            }).then(() => {
                this.handleOut();
            });
        },
        handleOut() {
            API.post('/api/aobiya/guest/logout').then(() => {
                localStorage.removeItem('orders');
                localStorage.removeItem('aobiyaUserInfos');
                localStorage.removeItem('userToken');
                localStorage.removeItem('viewFlag');
                this.$router.push({ name: 'home' });
                this.userToken = !!localStorage.getItem('aobiyaUserInfos');
                // window.location.reload();
                this.$message({
                    type: 'success',
                    message: '登出成功',
                });
            });
        },
        handleGoSearch() {
            this.$router.push({ name: 'SearchItems', query: { content: this.inputContent } });
        },
        fetchUserInfo() {
            API.get('api/aobiya/guest/token').then(res => {
                if (res.portrait_md5) {
                    this.avatarImg = res.portrait_md5;
                } else {
                    this.avatarImg = this.avatarTest;
                }
            });
        },
    },
    computed: {
        leftList() {
            if (localStorage.getItem('userToken')) {
                return [
                    {
                        title: 'Home',
                        link: 'home',
                        id: '',
                    },
                    {
                        title: 'Pre-sale',
                        link: 'presaleList',
                        id: 0,
                    },
                    {
                        title: 'Pre-sale in production',
                        link: 'presaleProduction',
                        id: 1,
                    },
                    {
                        title: 'Spot goods',
                        link: 'spotGoods',
                        id: 2,
                    },
                ];
            }
            return [
                {
                    title: 'Home',
                    link: 'home',
                    id: '',
                },
            ];
        },
    },
    created() {
        this.inputState = false;
        this.userToken = !!localStorage.getItem('aobiyaUserInfos');
    },
    mounted() {
        if (!window.headerBarMenuListener) {
            window.headerBarMenuListener = (e) => {
                if (!e.target.getAttribute('data-tag')) {
                    this.menuState = false;
                }
            };
            document.addEventListener('click', window.headerBarMenuListener);
        }
        this.$nextTick(() => {
            if (localStorage.getItem('aobiyaUserInfos')) {
                this.aobiyaUserInfos = JSON.parse(localStorage.getItem('aobiyaUserInfos'));
                this.fetchUserInfo();
            }
        });
    },
    destroyed() {
        window.headerBarMenuListener = null;
    },
};
</script>

<style lang="scss" scoped>
.container-top {
    min-width: 1200px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    position: fixed;
    width: 100%;
    z-index: 20;
    top: 0;
    left: 0;
    background-color: #fff;
}
.container-header {
    height: 71px;
    background-color: #fff;
    > div {
        width: 33.33%;
    }
    .container-header-left {
        font-size: 14px;
        color: #292220;
        letter-spacing: 0;
        line-height: 20px;
        span {
            cursor: pointer;
        }
    }
    .container-header-logo {
        height: 36px;
    }
    .container-header-center {
        width: 100%;
        background-image: url("../../assets/images/logo.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        height: 20px;
    }
    .container-header-right {
        > div {
            margin-left: 30px;
        }
    }
    .right-bar {
        .header-right-iconfont {
            white-space: nowrap;
            font-size: 18px;
            cursor: pointer;
        }
    }
}
.head-search {
    position: relative;
    input {
        font-size: 12px;
        color: #bbbbbb;
        width: 0;
        height: 0;
        transition: all 0.5s;
        border-radius: 15px;
        height: 32px;
        text-indent: 15px;
        caret-color: #70ceb6;
    }
    input.input-active {
        width: 280px;
        background: #f6f6f6;
    }
    span {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 10px;
    }
}
.avatar {
    width: 36px;
    height: 36px;
    position: relative;
    border-radius: 50%;
    border: 1px solid #70ceb6;
    background: #fff;
    .avatar-img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }
}
.avatar-father {
    position: relative;
    cursor: pointer;
    .menu {
        position: relative;
        &::after {
            content: "";
            width: 12px;
            height: 12px;
            position: absolute;
            box-shadow: -1px -1px 2px -1px rgba(0, 0, 0, 0.2);
            right: 15px;
            top: 44px;
            transform: rotate(45deg);
            background-color: #fff;
            z-index: 11;
        }
        ul {
            text-align: center;
            padding: 0 11px;
            top: 49px;
            right: 0px;
            user-select: none;
            position: absolute;
            background: #fff;
            box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
            border-radius: 2px;
            z-index: 10;
            li {
                font-size: 10px;
                color: #54525f;
                letter-spacing: 0;
                line-height: 14px;
                padding: 11px 5px;
                border-bottom: 1px solid #eeeeee;
                white-space: nowrap;
            }
            li:last-child {
                border: none;
            }
        }
    }
}
</style>
